angular
.module('app.views')
.controller('BoxcasterFormController', function($scope, $routeParams, $modalInstance, Boxcaster, Config, ElasticsearchService){
  $scope.config = Config;

  $scope.isSaving = false;

  $scope.isNew = !$routeParams.id;
  if (!$scope.isNew) {
    $scope.boxcaster = Boxcaster.get({id: $routeParams.id});
    $scope.boxcaster.$promise.then((b) => {
      if (!b.ethernet_address) {
        $scope.suggested_ethernet_address = b.id.substring(1);
      }
      if (!b.wireless_address) {
        if ($scope.canHaveWirelessMac(b)) {
          console.log('Attempting to look up wireless mac');
          // Poor-man's "last couple of days"
          const now = new Date,
                yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
          ElasticsearchService.query(ElasticsearchService.formatIndices(yesterday, now), {
            query: {
              bool: {
                filter: [
                    { query_string: { query: `hostname:(${b.id})` } },
                    { query_string: { query: "tag:(\"boxcaster.syslog.user\")" } },
                    { query_string: { query: "message:(\"wpa_action: address=\")" } },
                ]
              }
            },
            size: 1,
            sort: [ { '@timestamp': { order: 'desc' } } ],
          }).then((resp) => {
            if (resp.data && resp.data.hits && resp.data.hits.hits && (resp.data.hits.hits.length > 0) && resp.data.hits.hits[0]['_source'] && resp.data.hits.hits[0]['_source'].message) {
              const m = resp.data.hits.hits[0]['_source'].message.match(/wpa_action: address=([0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2})/);
              if (m && m[1]) {
                $scope.suggested_wireless_address = m[1].replace(/:/g, '').toLowerCase()
              } else {
                console.log('Wireless mac not found in hits', resp.data.hits);
              }
            } else {
                console.log('Wireless mac not found (no hits returned)', resp);
            }
          }).catch((e) => console.error(e));
        } else {
          console.log('Not attempting to look up wireless mac');
        }
      }
    }).catch((e) => console.error(e));
  }

  $scope.$watch('boxcaster.ethernet_address', function() {
    if ($scope.boxcaster && ($scope.boxcaster.ethernet_address !== null) && ($scope.boxcaster.ethernet_address !== undefined)) {
      return $scope.boxcaster.ethernet_address = $scope.boxcaster.ethernet_address.toLowerCase().replace(/[^0-9a-f]/g,'');
    }
  });

  $scope.$watch('boxcaster.wireless_address', function() {
    if ($scope.boxcaster && ($scope.boxcaster.wireless_address !== null) && ($scope.boxcaster.wireless_address !== undefined)) {
      return $scope.boxcaster.wireless_address = $scope.boxcaster.wireless_address.toLowerCase().replace(/[^0-9a-f]/g,'');
    }
  });

  $scope.canHaveWirelessMac = (b) => b && b.id && ((b.id[0] === 'o') || (b.id[0] === 'p'));

  $scope.useSuggestedEthernetAddress = () => {
    $scope.boxcaster.ethernet_address = $scope.suggested_ethernet_address;
    $scope.suggested_ethernet_address = null;
  }

  $scope.useSuggestedWirelessAddress = () => {
    $scope.boxcaster.wireless_address = $scope.suggested_wireless_address;
    $scope.suggested_wireless_address = null;
  }

  $scope.ok = function() {
    $scope.isSaving = true;

    const b = $scope.boxcaster;
    const updated = {
      id: b.id,
      backhaul_protocol: b.backhaul_protocol
    };
    if (b.ethernet_address) {
      updated.ethernet_address = b.ethernet_address;
    }
    if (b.wireless_address) {
      updated.wireless_address = b.wireless_address;
    }
    return Boxcaster.update(updated, b=> $modalInstance.close(b));
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/boxcaster/boxcaster_form_controller.js